import React, { useState } from "react";

import { getAllTagsFromResource } from "@examspark/common";
import { useQueryGetBank } from "@examspark/common-app";
import { CautionBanner, Toolbar } from "@examspark/common-ui";
import { ParsedObjectivesView } from "@examspark/types";

import ContentSection from "../../components/common/ContentSection";
import Objectives from "../../components/common/Objectives";
import UnitContent from "../../components/common/UnitContent";
import { Annotations } from "../../components/unit/Annotations";
import { useQuerySearchBonfireObjectives } from "../../hooks/useQueries";

import {
  ObjectiveFilterState,
  ObjectivesFilter,
  filterObjectives,
} from "./ObjectivesFilter";

type Props = {
  data: Extract<ParsedObjectivesView, { type: "CLARIFICATION" }>;
};

const ClarificationDocument = ({ data }: Props) => {
  const [filterOptions, setFilterOptions] = useState<ObjectiveFilterState>([]);

  const bank = useQueryGetBank(data?.bankId);
  const allowEnhancedClarification =
    data?.data?.isEnhanced &&
    !!getAllTagsFromResource(bank, "bonfire-allow-rce-mark").find(
      (t) => t.value === "tecd",
    );

  const objectivesQuery = useQuerySearchBonfireObjectives(data.objectiveScope);

  if (objectivesQuery.data == null) {
    return <CautionBanner>No standards found.</CautionBanner>;
  }

  return (
    <>
      <ContentSection
        title="TEKS Clarifications"
        actions={
          <Toolbar>{<Annotations resource={data} locationKey="TCD" />}</Toolbar>
        }
      >
        <div style={{ marginTop: "2rem" }}>
          <Objectives
            objectives={filterObjectives(filterOptions, objectivesQuery.data)}
            toolbar={
              <ObjectivesFilter
                filterOptions={filterOptions}
                setFilterOptions={setFilterOptions}
                filtersFor="objectives"
              />
            }
            initialShowSpecificity
            initialShowEnhancedClarification={allowEnhancedClarification}
            allowEnhancedClarification={allowEnhancedClarification}
            groupByScope={data.objectiveScope.length > 1}
          />
        </div>
      </ContentSection>

      {data.data?.bibliography && (
        <ContentSection title="Bibliography">
          <UnitContent content={data.data?.bibliography} />
        </ContentSection>
      )}
    </>
  );
};

export default ClarificationDocument;
